<template>
  <div>
    <dialassignitem
      ref="dialassignitem"
      :mode="mode"
      :selectedItem="selectedItem"
      :template="template"
      :to-edit="toEdit"
      @avalaible="avalaible = $event"
      @done="reload = true"
      @updateAssignItems="getAssignItems"
      v-model="dialog"
    />
    <div>
      <!-- Botón agregar -->
      <v-chip
        v-if="!qtyAssignItems"
        class="mr-2"
        color="success"
        @click.stop="open()"
      >
        <v-icon class="mr-1" small>fas fa-plus</v-icon>
        {{ $t('assign_people', { value: getTranslateMode(mode) }) }}
      </v-chip>

      <!-- Botón editar -->
      <v-chip v-else class="mr-2" color="primary" @click.stop="open()">
        <v-icon class="mr-1" small>fas fa-pencil</v-icon>
        {{ getTranslateMode(mode) }} ({{ qtyAssignItems }})
      </v-chip>

      <!-- Items asignados -->
      <div v-if="qtyAssignItems > 0" class="infoAssignItem p-3 mt-2 rounded">
        <v-chip
          v-for="assignItem in assignItems"
          :key="`${mode}-${assignItem.pk}`"
          class="mr-2"
          color="secondary"
          pill
          @click.stop="open()"
        >
          <v-avatar left v-if="mode != 'production'">
            <i-image
              :value="
                mode == 'driver'
                  ? assignItem.suborder.photo
                  : assignItem.user_data.photo
              "
              :preview="true"
              :readonly="true"
            />
          </v-avatar>
          {{
            mode == 'driver'
              ? assignItem.suborder.name
              : mode == 'designer'
              ? assignItem.user_data.name
              : assignItem?.department_object?.name
          }}
          <v-chip
            color="primary"
            class="ml-1"
            close
            @click:close="removeAssignation(assignItem)"
          >
            {{ $t(assignItem.status) }}
          </v-chip>
        </v-chip>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import dialassignitem from './dialAssignItem.vue'
export default {
  components: {
    dialassignitem
  },
  props: {
    selectedItem: {
      required: true,
      type: [String, Number]
    },
    mode: {
      default: 'designer',
      type: [String]
    },
    template: {
      type: Number
    }
  },
  data() {
    return {
      assignItems: [],
      avalaible: 0,
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    ...mapActions({
      showConfirmation: 'confirmation/confirmationValue'
    }),
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog =
        this.getPermissions([`sales.change_assigneduser`]) || this.isAdmin
      this.$refs.dialassignitem.open()
    },
    getAssignItems() {
      if (this.mode !== 'production') {
        this.$api.suborder.assigneduser
          .show({
            pk: this.selectedItem,
            opt: {
              params: {
                mode: this.mode
              }
            }
          })
          .then((response) => {
            this.assignItems = response.data
            this.$emit('onEndRequest')
            this.$emit('wasAssigned')
          })
      } else {
        this.$api.sale.assignedDepartment
          .list({
            opt: {
              params: {
                orderProduct: this.selectedItem
              }
            }
          })
          .then((response) => {
            this.assignItems = response.data.results
          })
      }
    },
    /**
     * getTranslateMode
     * @param mode
     */
    /**
     * sortCustomers
     * Método para guardar el id del cliente en el $store y redirigir a
     * crear orden de venta
     *
     * Angelo Osorio <danielking.321 at gmail.com>
     */
    getTranslateMode(mode) {
      const LOCALES_MODE = {
        designer: 'designer',
        production: 'department',
        delivery: 'driver'
      }

      return LOCALES_MODE[mode]
        ? this.$tc(LOCALES_MODE[mode])
        : this.$tc('suborder')
    },
    removeAssignation(assignationPK) {
      this.showConfirmation({
        show: true,
        model: `${this.$t('assigned', {
          value: this.getTranslateMode[this.mode]
        })}`,
        title: this.$tc('delete', 1),
        type: 'error white--text',
        content: this.$t('confirm_delete'),
        alert: `${this.$t('success', {
          model: `${this.$t('assigned', {
            value: this.getTranslateMode[this.mode]
          })}`,
          action: this.$tc('delete', 2)
        })}`,
        confirm: () => {
          const pk = assignationPK.pk
          if (this.mode == 'production') {
            this.$api.sale.assignedDepartment
              .remove({ pk })
              .then((response) => {
                if (response.status === 200 || response.status === 204) {
                  this.$emit('wasAssigned')
                }
              })
              .catch((error) => {
                console.error(error)
              })
          } else {
            this.$api.suborder.assigneduser.remove({ pk }).then((response) => {
              this.$emit('wasAssigned')
            })
          }
          this.assignItems = []
        }
      })
    }
  },
  computed: {
    qtyAssignItems() {
      return this.assignItems?.length || 0
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    })
  },
  watch: {
    selectedItem: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAssignItems()
        }
      }
    }
  }
}
</script>
<style lang="sass">
.infoAssignItem
  background-color: rgb(200 200 200 / .3)
  display: flex
  flex-direction: column
  align-items: baseline
  flex-wrap: wrap
  gap: 8px
.theme--dark
  .infoAssignItem
    background-color: rgb(0 0 0 / .25)
</style>
